import { getCookie } from './cookies';

export const isArabicLocale = (): boolean => {
  return getCookie('locale_player')?.toLocaleLowerCase() === 'ar';
};
